<template>
  <q-dialog
    :value="value"
    v-bind="$attrs"
    :maximized="maximizedToggle"
    v-on="$listeners"
  >
    <q-card style="min-width: 75vw;">
      <q-bar>
        <q-icon name="fa fa-edit" />
        <div class="ellipsis">
          {{ title }}
        </div>
        <q-space />
        <q-btn
          dense
          flat
          :icon="`fa fa-${maximizedToggle ? 'compress' : 'expand'}`"
          @click="maximizedToggle = !maximizedToggle"
        >
          <q-tooltip content-class="bg-white text-primary">
            {{ maximizedToggle ? 'Réduire' : 'Agrandir' }}
          </q-tooltip>
        </q-btn>
        <q-btn
          dense
          flat
          icon="fa fa-times"
          @click="onClose"
        >
          <q-tooltip content-class="bg-white text-primary">
            Fermer
          </q-tooltip>
        </q-btn>
      </q-bar>
      <div
        class="column no-wrap"
        :style="contentStyle"
      >
        <slot :contentStyle="contentStyle">
          <component
            :is="component.is"
            v-if="component"
            v-bind="component.props"
            ref="component"
            v-model="component.props.value"
            :style="contentStyle"
            :content-style="contentStyle"
            v-on="component.on"
            @close="close"
          />
        </slot>
      </div>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: 'LwfDialog',
  provide () {
    return {
      lwfDialog: this
    }
  },
  inheritAttrs: false,
  props: {
    value: Boolean,
    maximized: Boolean,
    component: {
      type: Object,
      default: undefined
    },
    title: {
      type: String,
      default: undefined
    }
  },
  data () {
    return {
      maximizedToggle: this.maximized
    }
  },
  computed: {
    contentStyle () {
      return this.maximizedToggle
        ? {
          height: 'calc(100vh - 32px)'
        }
        : {
          maxHeight: '75vh'
        }
    }
  },
  methods: {
    close () {
      this.$emit('input', false)
    },
    onClose () {
      if (this.component) {
        const { component: { $options: { beforeDialogClose } } } = this.$refs
        if (typeof beforeDialogClose === 'function') {
          return beforeDialogClose(this.$refs.component, this.close)
        }
      }
      this.close()
    }
  }
}
</script>

<style scoped>

</style>
